export const sizeOptions = ['xs', 'sm', 'md', 'lg'];

export const variantProps = ['linear', 'radial'];

export const colorOptions = ['primary', 'secondary'];
